import { api } from '@shared/api/api';

type WristbandData = App.Domain.Wristband.Data.WristbandData;

export const getWristbands = api.createIndex<WristbandData>('wristbands');
